// Englische Fassung von ../de/datasets.ts.
import type { DatasetsKatalog } from "../de/datasets";

export const datasets: DatasetsKatalog = {
  // List
  neuesDataset: "New dataset",
  dokumente: "Documents",
  web: "Web",
  zeilen: (n: number) => (n === 1 ? "1 row" : `${n} rows`),
  keineTabellen: "No tables yet",
  keineTabellenHinweis: "Create your first table from documents or from the web.",
  neueTabelle: "New table",

  // States
  status: {
    draft: "Draft",
    queued: "Queued",
    extracting: "Extracting",
    ready: "Ready",
    error: "Error",
  },
  abdeckung: (prozent: number) => `Coverage ${prozent} %`,

  // Runner diagnostics
  abschnitteUebersprungen: (n: number) =>
    `${n} section${n === 1 ? "" : "s"} skipped`,
  enumWerteGeleert: (n: number) => `${n} enum value${n === 1 ? "" : "s"} cleared`,
  faktenNichtAbgedeckt: (n: number) => `${n} fact${n === 1 ? "" : "s"} not covered`,
  nachschlagAusgefuehrt: "Follow-up pass executed",

  // Extraction state
  inWarteschlange: "Queued — extraction starts in a moment …",
  wirdExtrahiert: "Table is being extracted …",
  extraktionHinweis:
    "The model reads the document and fills the columns — typically 30–60s. This view refreshes automatically.",

  // Wizard
  name: "Name",
  quelle: "Source",
  dokumenteIngested: "Documents (ingested)",
  webDeepResearch: "Web (deep research)",
  dokumenteAuswaehlen: "Select documents",
  keineDokumenteHochgeladen: "No documents uploaded yet.",
  seedUrls: "Seed URLs (one per line, commas allowed)",
  mussEnthalten: "Must contain (keyword)",
  mussEnthaltenPlatzhalter: "e.g. breakfast",
  fakeHinweisVor: "Note: DEEP_RESEARCH_FAKE must be ",
  fakeHinweisNach:
    " and the deep research API must be reachable, otherwise you only get fake markdown.",
  spalten: "Columns",
  schemaVorschlagen: "Suggest schema",
  spalteHinzufuegen: "+ Column",
  spalteName: "Name",
  spalteTyp: "Type",
  spalteBeschreibung: "Description",
  datasetAnlegen: "Create dataset",
  erstDokumenteWaehlen: "Select documents for schema inference first.",

  // Detail
  laedt: "Loading …",
  zurueckZurListe: "Back to the dataset list",
  datasets: "Datasets",
  statusLabel: "Status:",
  csvTitel: "Download the visible (filtered + sorted) rows as CSV",
  csv: "CSV",
  run: "Run",
  laeuft: "running …",
  reparierenKlein: "repair",
  loeschenKlein: "delete",
  datasetLoeschen: "Delete dataset?",
  datasetReparieren: "Repair dataset?",
  reparierenBeschreibung:
    "Orphaned datasets (no source docs left) are deleted, empty ones are rebuilt, intact ones stay untouched.",
  reparieren: "Repair",
  ok: "OK",
  repairGeloescht: "The dataset was orphaned (no docs left) and has been deleted.",
  repairNeuAufgebaut: "The dataset had 0 rows — a rebuild has been triggered.",
  repairInOrdnung: (zeilen: number) => `All good (${zeilen} rows).`,

  tabTabelle: "Table",
  tabChat: "Chat",
  erstRunAusfuehren: "Run it first",
  extraktionFehlgeschlagen: "Extraction failed",
  unbekannterFehler: "Unknown error — please start the run again.",

  // Table
  suchePlatzhalter: "Search dataset rows semantically …",
  sucheAria: "Search dataset rows semantically",
  limitErreicht: (zeilen: string, geladen: string) =>
    `Limit reached: the dataset has ${zeilen} rows, only ${geladen} are loaded. Sorting + filtering only operate on the loaded rows — server-side filtering is still to come.`,
  horizontalScrollen: "← scroll the table horizontally →",
  section: "Section",
  headingPfad: "Heading path",
  sortierungUmschalten: "Toggle sorting (asc → desc → off)",
  filternPlatzhalter: "filter …",
  spalteFiltern: (spalte: string) => `Filter column ${spalte}`,
  statusRunStarten: (status: string) => `Status: ${status} — start a run to produce rows.`,
  keineZeilen: "No rows — start a run or search again.",
  filterOhneTreffer: "No matches for these filters — adjust or clear them.",
  dokument: "Document",
  quelleMitSeite: (bezeichnung: string, seite: string) => `${bezeichnung} · p.${seite}`,
};
